module.exports = __webpack_public_path__ + "assets/about-bloqhouse.53ec50aa.svg";